<template>
  <div id="filter-navigation-type">
    <div>
      <vs-row vs-type="flex" class="mt-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="6"
        >
          <span class="aisea-text-16-400-white">全て</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="6"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="allSwitch"/>
        </vs-col>
      </vs-row>

      <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>
      <!-- 灯台 -->
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-navigation-img" :src="lighthouseIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">灯台</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="lighthouseSwitch"/>
        </vs-col>
      </vs-row>
      <!-- 灯浮標 -->
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-navigation-img" :src="lightBuoyIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">灯浮標</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="lightBuoySwitch"/>
        </vs-col>
      </vs-row>
      <!-- 灯標 -->
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-navigation-img" :src="lightBeaconIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">灯標</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="lightBeaconSwitch"/>
        </vs-col>
      </vs-row>
      <!-- その他 -->
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-navigation-img" :src="otherIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">その他</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="otherSwitch"/>
        </vs-col>
      </vs-row>
      <!-- 海上交通安全法の航路 -->
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-navigation-img" :src="maritimeTrafficRegulationsIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">海上交通安全法の航路</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="maritimeTrafficRegulationsSwitch"/>
        </vs-col>
      </vs-row>
      <!-- 港則法の航路 -->
      <vs-row vs-type="flex" class="mt-6">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="1"
        >
          <img class="filter-navigation-img" :src="portTrafficRegulationsIcon">
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-16-400-white ml-5">港則法の航路</span>
        </vs-col>
        <vs-col
          vs-order="3"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
          <vs-switch :color="AISEA_COLOR.BLUE" v-model="portTrafficRegulationsSwitch"/>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import {NavigationsMixin, ColorMixin} from "@/mixins";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import {createNamespacedHelpers} from "vuex";
import _ from "lodash";

// Store
const {mapActions: mapActionsOfLiveMap} = createNamespacedHelpers("liveMap");

export default {
  name: "NavigationDisplaySetting",
  mixins: [NavigationsMixin, ColorMixin],
  components: {},
  data() {
    return {
      isAllSwitchOnEvent: false,
      isAllFilterOffEvent: false,
      localFilterNavigations: [],
      allSwitch: false,
      maritimeTrafficRegulationsSwitch: false,
      portTrafficRegulationsSwitch: false,
      lighthouseSwitch: false,
      lightBuoySwitch: false,
      lightBeaconSwitch: false,
      otherSwitch: false,
      maritimeTrafficRegulationsIcon: require("@/assets/images/navigations/maritimeTrafficRegulations.svg"),
      portTrafficRegulationsIcon: require("@/assets/images/navigations/portTrafficRegulations.svg"),
      lighthouseIcon: require("@/assets/images/navigations/navigationalAidsLighthouse.svg"),
      lightBuoyIcon: require("@/assets/images/navigations/navigationalAidsLightBuoy.svg"),
      lightBeaconIcon: require("@/assets/images/navigations/navigationalAidsLightBeacon.svg"),
      otherIcon: require("@/assets/images/navigations/navigationalAidsOther.svg"),
    };
  },
  computed: {},
  watch: {
    localFilterNavigations(val) {
      this._setFilterNavigations(this, val)
    },
    async allSwitch(isOn) {
      if (isOn) {
        if (!this.isAllSwitchOnEvent) {
          await this.setAllFilter(true)
          let categoryIds = this.getNavigationsCategoryIds();
          this.localFilterNavigations = categoryIds;
        } else {
          this.isAllSwitchOnEvent = false
        }
      } else {
        this.localFilterNavigations = [];
        this.isAllFilterOffEvent = true
        await this.setAllFilter(false)
        this.isAllFilterOffEvent = false
      }
    },
    maritimeTrafficRegulationsSwitch(isOn) {
      this.setFilterState(isOn, String(this.navigationsCategory.MARITIME_TRAFFIC_REGULATIONS_ROUTE))
    },
    portTrafficRegulationsSwitch(isOn) {
      this.setFilterState(isOn, String(this.navigationsCategory.PORT_TRAFFIC_REGULATIONS_ROUTE))
    },
    lighthouseSwitch(isOn) {
      this.setFilterState(isOn, String(this.navigationsCategory.LIGHTHOUSE))
    },
    lightBuoySwitch(isOn) {
      this.setFilterState(isOn, String(this.navigationsCategory.LIGHT_BUOY))
    },
    lightBeaconSwitch(isOn) {
      this.setFilterState(isOn, String(this.navigationsCategory.LIGHT_BEACON))
    },
    otherSwitch(isOn) {
      this.setFilterState(isOn, String(this.navigationsCategory.OTHER))
    },
  },
  methods: {
    ...mapActionsOfLiveMap(["setFilterNavigations"]),
    _setFilterNavigations: _.debounce((self, val) => {
      let filterNavigations = _.cloneDeep(val)
      FireStoreService.saveFilterNavigations(filterNavigations)
      LocalDbService.saveFilterNavigations(filterNavigations);
      self.setFilterNavigations(filterNavigations);
    }, 1000),
    setFilterState(isOn, navigationsCategory) {
      if (this.isAllFilterOffEvent) return
      if (isOn) {
        this.localFilterNavigations.push(navigationsCategory)
      } else {
        this.filterPlot(navigationsCategory)
      }
      if (this.localFilterNavigations.length === 0) {
        this.allSwitch = false
      }
      if (this.getNavigationsCategoryIds().length === this.localFilterNavigations.length) {
        this.allSwitch = true
      }
    },
    filterPlot(id) {
      this.localFilterNavigations = this.localFilterNavigations.filter(v => {
        return v !== id
      })
    },
    async setAllFilter(val) {
      this.maritimeTrafficRegulationsSwitch = val;
      this.portTrafficRegulationsSwitch = val;
      this.lighthouseSwitch = val;
      this.lightBuoySwitch = val;
      this.lightBeaconSwitch = val;
      this.otherSwitch = val;
    },
    async setFilterSwitch(filterNavigations) {
      filterNavigations.forEach(type => {
        switch (Number(type)) {
          case this.navigationsCategory.MARITIME_TRAFFIC_REGULATIONS_ROUTE :
            this.maritimeTrafficRegulationsSwitch = true;
            break;
          case this.navigationsCategory.PORT_TRAFFIC_REGULATIONS_ROUTE :
            this.portTrafficRegulationsSwitch = true;
            break;
          case this.navigationsCategory.LIGHTHOUSE:
            this.lighthouseSwitch = true;
            break;
          case this.navigationsCategory.LIGHT_BUOY:
            this.lightBuoySwitch = true;
            break;
          case this.navigationsCategory.LIGHT_BEACON:
            this.lightBeaconSwitch = true;
            break;
          case this.navigationsCategory.OTHER:
            this.otherSwitch = true;
            break;
        }
      })
    },
  },
  async created() {
    let filterNavigations = await LocalDbService.getFilterNavigations();
    if (filterNavigations.length === 0) {
      this.allSwitch = false;
      await this.setAllFilter(false)
      this.localFilterNavigations = filterNavigations;
    } else {
      await this.setFilterSwitch(filterNavigations)
      this.localFilterNavigations = filterNavigations;
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#filter-navigation-type {
  background: $aisea-blue-gray;

  .filter-navigation-img {
    height: 20px;
    width: 20px;
  }
}
</style>
